import { PrelineScript } from '@iveco-ti/iveco-ds'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import flagsmith from 'flagsmith'
import { FlagsmithProvider } from 'flagsmith/react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { ToastContainer } from 'react-toastify'

import { AppRoutes } from './app.routes'
import { ENV } from './common/constants/env'

import './index.css'
import './lib/i18n'
import './lib/sentry'

import { Modal } from './common/components/Modal'
import { ModalApplication } from './common/components/ModalApplication'
import { ModalApplicationProvider } from './common/components/ModalApplicationProvider'
import { ModalProvider } from './common/components/ModalProvider'
import { queryClient } from './lib/tanstack'

function App() {
  return (
    <FlagsmithProvider
      options={{
        environmentID: ENV.VITE_FLAGSMITH_ID,
        cacheFlags: true,
      }}
      flagsmith={flagsmith}
    >
      <NuqsAdapter>
        <QueryClientProvider client={queryClient}>
          <ModalProvider>
            <ModalApplicationProvider>
              <AppRoutes />

              <ToastContainer
                position="top-right"
                newestOnTop
                hideProgressBar
                closeButton={false}
              />
              <Modal />
              <ModalApplication />
            </ModalApplicationProvider>
          </ModalProvider>
          <PrelineScript />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-left" />
        </QueryClientProvider>
      </NuqsAdapter>
    </FlagsmithProvider>
  )
}

export default App
